var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vacancy-item-links"},_vm._l((_vm.activeModules),function(module){return _c('span',[_c('router-link',{attrs:{"disabled":_vm.disabled,"tag":"a","target":_vm.target,"to":_vm.routes[module.name]}},[_c('i',{class:_vm.icons[module.name]})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }